import { HStack, Icon, Text, Tooltip } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';
import { Pressable } from 'react-native';

export interface RecommendedPortfolioBadgeProps {
  hasRecommendedPortfolioLink: boolean;
  recommendedPortfolioLinks: string[];
  hideText?: boolean;
}

export const RecommendedPortfolioBadge: React.FC<RecommendedPortfolioBadgeProps> = ({
  hasRecommendedPortfolioLink,
  recommendedPortfolioLinks,
  hideText,
}) => {
  if (!hasRecommendedPortfolioLink) {
    return null;
  }

  return (
    <Tooltip label={recommendedPortfolioLinks.join('\n')}>
      <Pressable>
        <HStack
          width="fit-content"
          space="inline.quarck"
          px="inline.nano"
          py="stack.quarck"
          borderRadius={BoxBorder.heavy}
          alignItems="center"
          bg="scale.teal.50">
          <Icon name="Wallet" size="xxxs" color="scale.teal.900" />
          {!hideText && (
            <Text color="scale.teal.900" fontSize="xs" variant="semibold">
              Carteira Recomendada
            </Text>
          )}
        </HStack>
      </Pressable>
    </Tooltip>
  );
};
